module.exports = __webpack_public_path__ + "img/home-icon.8fa8e388.svg";